<template>
  <b-tab title="Learners" lazy>
    <div slot="title">
      <span class="font-size-md active">Learners</span>
      <div class="divider"></div>
    </div>

    <b-row class="justify-content-center">
      <b-col v-if="totalLearners > 0" md="8">
        <div v-for="(learner, index) in learnerChunk" :key="index">
          <div
            class="learner d-flex align-items-center py-u2 px-u4 rounded"
            @click="goToPageLearner(learner.id)"
          >
            <!-- <BaseAvatar
              :size="44"
              :name="`${learner.firstname} ${learner.lastname}`"
              class="mr-u3"
            /> -->
            <BaseUserProfile
              :user-name="`${learner.firstname} ${learner.lastname}`"
              :picture="learner.profile_picture"
              class="mr-u3"
            />
            <div>
              <div class="learner__name">{{ learner.firstname }} {{ learner.lastname }}</div>
              <div class="learner__email text-dark">
                {{ learner.email }}
              </div>
            </div>
            <!-- <font-awesome-icon
              :icon="{ prefix: 'fas', iconName: 'chevron-right' }"
              class="ml-auto"
            /> -->
          </div>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalLearners"
          :per-page="perPage"
          align="center"
          class="mt-u15"
        />
      </b-col>

      <div v-else class="text-center">
        <div class="no-message__title">No enrolled learners</div>

        <div class="no-message__body mt-2">All enrolled learners will be displaying here</div>
      </div>
    </b-row>
  </b-tab>
</template>

<script>
import BaseUserProfile from '@/components/base-components/BaseUserProfile.vue';

export default {
  components: {
    BaseUserProfile
  },
  props: {
    active: {
      type: [Number, Boolean],
      default: false
    },
    learners: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      currentPage: 1,
      perPage: 20
    };
  },

  computed: {
    totalLearners() {
      return this.learners.length;
    },

    learnerChunk() {
      return this.learners.slice(
        (this.currentPage - 1) * this.perPage,
        (this.currentPage - 1) * this.perPage + this.perPage
      );
    }
  },

  methods: {
    goToPageLearner(learnerId) {
      // return this.$router.push({ name: "learner", params: { learnerId } });
      return learnerId;
    }
  }
};
</script>

<style scoped>
/* .learner {
  cursor: pointer;
}

.learner:hover {
  background-color: var(--light);
}

.learner:hover .learner__name {
  color: var(--second);
} */

.learner__name {
  color: var(--primary);
}

.learner__email {
  font-size: 12.16px;
}
</style>
